import { Box } from "@mui/material";
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import * as yup from "yup";
import { ToolbarAnalysis } from "../../../shared/components";
import { IVFormErros, useVForm, VForm } from "../../../shared/forms";
import { LayoutBaseDePagina } from "../../../shared/layouts";
import { CapitalizationInitialDataSection } from "./CapitalizationFormSections/CapitalizationInitialDataSection";
import { CapitalizationPropertySection } from "./CapitalizationFormSections/CapitalizationPropertySection";
import { CapitalizationTenantSection } from "./CapitalizationFormSections/CapitalizationTenantSection";
import { capitalizationFormSchema } from "./schemas";

interface ICapitalizationFormProps {
    onSubmit: (data: any) => void;
    initialData?: any;
}

export const CapitalizationForm: React.FC<ICapitalizationFormProps> = ({ onSubmit, initialData }) => {
    const navigate = useNavigate();
    const { formRef, save } = useVForm();

    useEffect(() => {
        if (initialData) {
            formRef.current?.setData(initialData);
        }
    }, [initialData]);

    const handleSave = async (data: any) => {
        try {
            console.log("Tentando salvar dados:", data);
            await capitalizationFormSchema.validate(data, { abortEarly: false });
            console.log("Validação bem sucedida!");
            onSubmit(data);
        } catch (errors) {
            console.error("Erro de validação:", errors);
            const validationErrors: IVFormErros = {};
            if (errors instanceof yup.ValidationError) {
                errors.inner.forEach((error) => {
                    if (!error.path) return;
                    validationErrors[error.path] = error.message;
                });
                console.log("Erros mapeados:", validationErrors);
                formRef.current?.setErrors(validationErrors);
            }
        }
    };

    return (
        <LayoutBaseDePagina
            titulo="Capitalização"
            subtitulo={initialData?.id ? "Editar Título de Capitalização" : "Novo Título de Capitalização"}
            barraDeFerramentas={
                <ToolbarAnalysis
                    clickAnalysis={save}
                    textButtonAnalysis="Salvar"
                    clickBack={() => navigate("/capitalizacao")}
                    showButtonCancel={false}
                    showButtonProposal={false}
                    showButtonEmailresend={false}
                    showButtonReAnalysis={false}
                    showButtonExit={false}
                />
            }
        >
            <Box sx={{ width: "100%", maxWidth: "1300px" }}>
                <VForm ref={formRef} onSubmit={handleSave} onPointerEnterCapture={''} onPointerLeaveCapture={''} placeholder={''}>
                    <CapitalizationInitialDataSection data={initialData} formRef={formRef} />
                    <CapitalizationPropertySection data={initialData} formRef={formRef} />
                    <CapitalizationTenantSection data={initialData} formRef={formRef} />
                </VForm>
            </Box>
        </LayoutBaseDePagina>
    );
};
